//////////////////////////////

module.exports = (type) => {
    var schema = {
        email: {
            type: type.STRING(64),
            isEmail: true,
            allowNull: false,
        },
        created: {
            type: type.DATE,
            allowNull: false,
            defaultValue: type.NOW,
        },
        last_name: {
            type: type.STRING(64),
            allowNull: false,
        },
        first_name: {
            type: type.STRING(64),
            allowNull: false,
        },
        hash: {
            type: type.STRING(128),
            allowNull: false,
        },
        role_id: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'roles',
                key         : 'id',
                constraints : true,
                store_name  : 'role',
            }
        },
        customer_id: {
            type: type.INTEGER,
            allowNull: true,
            references: {
                model       : 'customers',
                key         : 'id',
                constraints : true,
                store_name  : 'customer',
            }
        },
        enabled: {
            type: type.BOOLEAN,
            allowNull: false,
            defaultValue: true,
        },
        id: {
          type: type.INTEGER,
          primaryKey: true,
          autoIncrement: true
        },
    };

    return schema;
}

